'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

RouteMapDirective=function(_BaseControllerBacked){_inherits(RouteMapDirective,_BaseControllerBacked);function RouteMapDirective(){_classCallCheck(this,RouteMapDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(RouteMapDirective,[{key:'templateUrl',get:function()
{
return'/templates/directives/routeMapDirective/routeMapTemplate';
}},{key:'objectBindings',get:function()
{
return[
'routePath',
'stops'];

}},{key:'controller',get:function()
{
return Controller;
}}]);return RouteMapDirective}(BaseControllerBackedDirective);let


Controller=function(){_createClass(Controller,null,[{key:'$inject',get:function()
{return['$scope','leafletBoundsHelpers']}}]);

function Controller($scope,leafletBoundsHelpers){_classCallCheck(this,Controller);
this._leafletBoundsHelpers=leafletBoundsHelpers;

this.leafletPaths=this._createLeafletPathFromRoutePath();
this.leafletMarkers=this._createLeafletMarkersFromRouteStops();

this.routeBounds=this._getRouteBounds();
}Controller.prototype.

_createLeafletMarkersFromRouteStops=function _createLeafletMarkersFromRouteStops(){
if(!_.exists(this.stops)){
return[];
}

return this.stops.map(function(s){

let{street:street,city:city,state:state,zip:zip}=s.location;
let addressString=_.compact([street,city,state,zip]).join(', ');

let stopType=s.stopType==='drophook'?'Drop and Hook':s.stopType;

let message=stopType==='none'?addressString:`${_.upperFirst(s.stopType)}: ${addressString}`;

return{
lat:s.location.latlng.lat,
lng:s.location.latlng.lng,
message:message,
focus:!1,
draggable:!1};

});
};Controller.prototype.

_createLeafletPathFromRoutePath=function _createLeafletPathFromRoutePath(){
if(!_.exists(this.routePath)){
return[];
}

let routePathColor='#758FF2';
let routePathWeight=8;
let leafletPathObject={
color:routePathColor,
weight:routePathWeight,
latlngs:this.routePath};


return[leafletPathObject];
};Controller.prototype.

_getRouteBounds=function _getRouteBounds(){
let latitudes=_.map(this.routePath,'lat');
let longitudes=_.map(this.routePath,'lng');

let northernLatitude=_.max(latitudes);
let southernLatitude=_.min(latitudes);
let westernLongitude=_.max(longitudes);
let easternLongitude=_.min(longitudes);

let pathLocationsArray=[
[northernLatitude,easternLongitude],
[southernLatitude,westernLongitude]];


return this._leafletBoundsHelpers.createBoundsFromArray(pathLocationsArray);
};return Controller}();


module.exports=RouteMapDirective;
//# sourceMappingURL=routeMapDirective.js.map
